import {
    getAllAnnouncementByAdmin,
    addNewAnnouncementByAdmin,
    getAnAnnouncement,
    updateAnnouncementByAdmin,
    deleteAnnouncementByAdmin,
    getAllAnnouncement,
} from '../../services/announcement'
import { errorHandler } from '../../utils/errorHandler'
import { notification } from '../notification/notificationActions'
import { announcementTypes } from './announcementTypes'
import { userTypes } from '../user/userTypes'
//Add New Announcement By Admin
export const addNewAnnouncementByAdminAction = (body, closeModal) => async (
    dispatch,
    getState
) => {
    const { allAdminAnnouncement } = getState().announcement
    dispatch({
        type: announcementTypes.ADD_NEW_ANNOUNCEMENT_BY_ADMIN_START,
    })
    try {
        const { data } = await addNewAnnouncementByAdmin(body)
        const addAnnouncementByAdmin = [...allAdminAnnouncement, data?.data]

        dispatch({
            type: announcementTypes.ADD_NEW_ANNOUNCEMENT_BY_ADMIN_SUCCESS,
            payload: addAnnouncementByAdmin,
        })

        dispatch(
            notification({
                message: 'اطلاعیه شما با موفقیت ثبت شد',
                variant: 'success',
            })
        )

        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            announcementTypes.ADD_NEW_ANNOUNCEMENT_BY_ADMIN_FAILED,
            error,
            allAdminAnnouncement
        )
    }
    dispatch({
        type: announcementTypes.ADD_NEW_ANNOUNCEMENT_BY_ADMIN_END,
    })
}

//get All Announcement By Admin
export const getAllAnnouncementByAdminAction = body => async dispatch => {
    dispatch({
        type: announcementTypes.GET_ALL_ANNOUNCEMENT_BY_ADMIN_START,
    })
    try {
        const { data } = await getAllAnnouncementByAdmin(body)
        dispatch({
            type: announcementTypes.GET_ALL_ANNOUNCEMENT_BY_ADMIN_SUCCESS,
            payload: data?.data,
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(
            dispatch,
            announcementTypes.GET_ALL_ANNOUNCEMENT_BY_ADMIN_FAILED,
            error
        )
    }
    dispatch({
        type: announcementTypes.GET_ALL_ANNOUNCEMENT_BY_ADMIN_END,
    })
}

//update Announcement By Admin
export const updateAnnouncementByAdminAction = (id, body, closeModal) => async (
    dispatch,
    getState
) => {
    const { allAdminAnnouncement } = getState().announcement
    const index = allAdminAnnouncement.findIndex(
        selectedAdminAnnouncement => selectedAdminAnnouncement.id === id
    )

    dispatch({
        type: announcementTypes.UPDATE_ANNOUNCEMENT_BY_ADMIN_START,
    })
    try {
        const { data } = await updateAnnouncementByAdmin(id, body)
        allAdminAnnouncement[index] = data?.data
        dispatch({
            type: announcementTypes.UPDATE_ANNOUNCEMENT_BY_ADMIN_SUCCESS,
            payload: allAdminAnnouncement,
        })
        dispatch(
            notification({
                message: `اطلاعیه شما به روز رسانی شد`,
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            announcementTypes.UPDATE_ANNOUNCEMENT_BY_ADMIN_FAILED,
            error,
            allAdminAnnouncement
        )
    }
    dispatch({
        type: announcementTypes.UPDATE_ANNOUNCEMENT_BY_ADMIN_END,
    })
}

//delete Announcement By Admin
export const deleteAnnouncementByAdminAction = (id, closeModal) => async (
    dispatch,
    getState
) => {
    const { allAdminAnnouncement } = getState().announcement
    const filteredAdminAnnouncement = allAdminAnnouncement.filter(
        announcement => announcement.id !== id
    )
    dispatch({
        type: announcementTypes.DELETE_ANNOUNCEMENT_BY_ADMIN_START,
    })
    try {
        const { data } = await deleteAnnouncementByAdmin(id)
        dispatch({
            type: announcementTypes.DELETE_ANNOUNCEMENT_BY_ADMIN_SUCCESS,
            payload: filteredAdminAnnouncement,
        })
        dispatch(
            notification({
                message: 'اطلاعیه مورد نظر با موفقیت حذف شد',
                variant: 'success',
            })
        )
        closeModal && closeModal()
    } catch (error) {
        errorHandler(
            dispatch,
            announcementTypes.DELETE_ANNOUNCEMENT_BY_ADMIN_FAILED,
            error,
            allAdminAnnouncement
        )
    }
    dispatch({
        type: announcementTypes.DELETE_ANNOUNCEMENT_BY_ADMIN_END,
    })
}

//get An Announcement
export const getAnAnnouncementAction = id => async dispatch => {
    dispatch({
        type: announcementTypes.GET_AN_ANNOUNCEMENT_START,
    })
    try {
        const { data } = await getAnAnnouncement(id)
        dispatch({
            type: announcementTypes.GET_AN_ANNOUNCEMENT_SUCCESS,
            payload: data?.data,
        })
        if (data?.data.seen) {
            dispatch({
                type: userTypes.DECREASE_UN_SEEN_ANNOUNCEMENT_START,
            })
        }
    } catch (error) {
        errorHandler(
            dispatch,
            announcementTypes.GET_AN_ANNOUNCEMENT_FAILED,
            error
        )
    }
    dispatch({
        type: announcementTypes.GET_AN_ANNOUNCEMENT_END,
    })
}

//get all Announcement
export const getAllAnnouncementAction = body => async dispatch => {
    dispatch({
        type: announcementTypes.GET_ALL_ANNOUNCEMENT_START,
    })
    try {
        const { data } = await getAllAnnouncement(body)
        dispatch({
            type: announcementTypes.GET_ALL_ANNOUNCEMENT_SUCCESS,
            payload: data?.data,
            meta: data?.meta,
        })
    } catch (error) {
        errorHandler(
            dispatch,
            announcementTypes.GET_ALL_ANNOUNCEMENT_FAILED,
            error
        )
    }
    dispatch({
        type: announcementTypes.GET_ALL_ANNOUNCEMENT_END,
    })
}
